<template>
<div class="page tableofcontents">
  <a name="impact-objectives"/>
  <p class="preheader">Strategic Priorities</p>
  <p class="dustin-title ">
    Your Impact Objectives
  </p>
  <br>
  <p class="description">
    Methodology
  </p>
  <p class="criteria">
    This page organizes your impact priorities into broad areas, such as health and environment. Each area contains specific metrics available for impact reporting. SDGs are mapped onto each area to facilitate stakeholder communication around the areas of focus.
  </p>

  <section class="section print-no-break" v-for="(metricList, slug) in reportMetricsByEsgIssue">
    <div class="columns is-vcentered">
      <div class="column is-two-thirds">
        <div class="columns is-8 is-variable is-vcentered">
          <div class="column is-one-fifth ">
            <span v-bind:class="`icon has-text-${slug}`">
              <i v-bind:class="`${metricList[0].details.subcategory[0].esgissue.icon} fa-lg fa-3x`"></i>
            </span>
          </div>
          <div class="column is-four-fifths">

            <p class="preheader">
              <template v-if="slug === 'environment'">
                a cleaner <u>environment</u>
              </template>
              <template v-if="slug === 'accountability'">
                <u>accountability</u> for corporations
              </template>
              <template v-if="slug === 'equal-opportunity'">
                <u>equality</u> in opportunity
              </template>
              <template v-if="slug === 'health'">
                a <u>healthier</u> public
              </template>
              <template v-if="slug === 'human-rights'">
                respect for <u>human rights</u>
              </template>
            </p>

            <p class="tags ">
              <span
                v-for="(metric, index) in metricList"
                v-bind:class="`tag is-${slug}`"
              >
                {{ metric.name }}
              </span>
            </p>
          </div>
        </div><!-- columns -->

      </div>
      <div class="column is-one-third">
        <div class="sdgflex">
          <img
            class="sdg"
            v-for="(sdg, index) in sdgMappings[slug]"
            v-bind:key="`${index}-${sdg}`"
            v-bind:src="`${$root.$data.STATIC_ROOT}sillyimages/${sdg}.png`"
          >
        </div>
      </div>
    </div>
  </section>

</div>
</template>


<script>
  export default {
    components: {
    },
    data () {
      return {
        sdgMappings: {
          'environment': [
              'sdg7',
              'sdg11',
              'sdg12',
              'sdg13',
              'sdg14',
              'sdg15',
          ],
          'health':  [
            'sdg2',
            'sdg3',
            'sdg6',
          ],
          'equal-opportunity':  [
            'sdg4',
            'sdg5',
            'sdg10',
           ],
          'accountability':  [
            'sdg9',
            'sdg16',
            'sdg17',
            ],
          'human-rights':  [
            'sdg1',
            'sdg8',
            ],
        },
        datacollection: {},
      }
    },
    props: {
      portfolio: Object,
    },
    computed: {
      reportMetricsByEsgIssue: function() {
        if (this.portfolio.impact_report) {
          return this.portfolio.impact_report.report.metrics.reduce((acc, itm) => {
            if (!(itm.esgissue_slug in acc)) {
              acc[itm.esgissue_slug] = [];
            }
            acc[itm.esgissue_slug].push(itm);
            return acc;
          }, {});
        }
        else {
          return {};
       }
      }
    },
    mounted () {
      document.addEventListener('DOMContentLoaded', function () {
          var initiallist = document.getElementsByClassName('initialshow');
          var morelist = document.getElementsByClassName('moreshow');
          var upanglelist = document.getElementsByClassName('lessicon');
          var downanglelist = document.getElementsByClassName('moreicon');
          for (var i = 0; i < initiallist.length; i++) (function (i) {
              downanglelist[i].onclick = function () {
                  morelist[i].style.display = "inline";
                  initiallist[i].style.display = "none";
              }
              upanglelist[i].onclick = function () {
                  initiallist[i].style.display = "inline";
                  morelist[i].style.display = "none";
              }
          })(i);
      });
    },
  }

</script>

<style lang="css" scoped>
  .persona_vegan .icon {
    color: #5aa9e6;
  }
  .persona_environmentalist .icon {
    color: #93C48B;
  }
  .persona_racial_justice .icon {
    color: #685369;
  }
  .persona_feminist .icon {
    color: #f1ab86;
  }
  .persona_virtuous .icon {
    color: #78CAD2;
  }
  .persona_labor .icon {
    color: #A40E4C;
  }
  .persona_law_and_order .icon {
    color: #8499B1;
  }

  .additional-notes {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .additional-notes label, #notes-input {
    display: block;
    width: 75%;
    margin: 0 auto;
  }

  #notes-input {
    background-color: #fff;
    padding: 5px;
    height: 150px;
    margin: 15px auto;
    border: 2px solid lightgray;
  }

  .actions {
    text-align: center;
    margin: 0 auto;
  }

  .actions > a {
    display: block;
    margin-top: 20px;
  }

.moreshow {
  /* display: none */
}

.sdgflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.sdg {
  margin: .25rem;
  width: 3.95rem;
  height: 3.95rem;
}

</style>
